'use strict';
const mmWidgets = require('./mm-widgets'),
	ThemeProcessor = require('@mindmup/mapjs-core/src/theme/theme-processor');
mmWidgets.fn.themeCssWidget = function (mapThemeModel, optional) {
	if (!mapThemeModel) {
		throw 'invalid-args';
	}
	return mmWidgets.each(this, function () {
		const element = this,
			themeProcessor = (optional && optional.themeProcessor) || new ThemeProcessor(),
			activateTheme = (themeJson) => element.text(themeProcessor.process(themeJson).css);

		mapThemeModel.addEventListener('themeJSONChanged', activateTheme);
	});
};

